import { useTranslation } from 'react-i18next'

/** Placeholder — monitoring-source configuration lands in epic 7. */
export function SourcesPage() {
  const { t } = useTranslation()
  return <h2 className="text-xl font-semibold">{t('nav.sources')}</h2>
}
